







































import ExercisesStrengthening from '@/components/exercises/measure/ExercisesStrengthening.vue'
import * as R from 'ramda'
import { EMPTY_STRENGTHENING_EXERCISE } from '@/store/modules/exercise/constants'

export default {
  components: {
    ExercisesStrengthening,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      validator: obj => ['id', 'strengtheningExercises'].every(key => key in obj),
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateStrengtheningExercise(index: number, name: string, value: any) {
      const copiedStrengtheningExercise = R.clone(this.exercise.strengtheningExercises)
      const target = this.exercise.strengtheningExercises[index]
      copiedStrengtheningExercise.splice(index, 1, {
        ...target,
        [name]: value,
      })
      this.$emit('update:exercise-param', 'strengtheningExercises', copiedStrengtheningExercise)
    },
    deleteStrengtheningExercise(index: number) {
      const copiedStrengtheningExercise = R.clone(this.exercise.strengtheningExercises)
      copiedStrengtheningExercise.splice(index, 1)
      this.$emit('update:exercise-param', 'strengtheningExercises', copiedStrengtheningExercise)
    },
    addEmptyStrengtheningExercise() {
      const copiedStrengtheningExercise = R.clone(this.exercise.strengtheningExercises)
      copiedStrengtheningExercise.push(EMPTY_STRENGTHENING_EXERCISE)
      this.$emit('update:exercise-param', 'strengtheningExercises', copiedStrengtheningExercise)
    },
  },
}
